import React from "react";
import { ReactComponent as TitleImage } from "../../../../../assets/svgs/TitleIcons.svg";
import TwoBarHorizontalGraph from "../common/MultipleBarGraph";
import { THEME_COLORS } from "../../../../../color";

const HealthAndSafety = ({ getComponent, activeDashboard }) => {
  const comp = getComponent ? getComponent("soc_hs_incidents") : null;

  // Default fallback data
  let empPrevData = [4, 2, 1.6, 0.8, 0, 1, 2, 4, 4.5];
  let empCurrData = [3, 1, 1.2, 0.4, 0, 1, 2, 3, 3];
  let wkrPrevData = [6, 3, 2.4, 1.2, 0, 2, 3, 6, 6.8];
  let wkrCurrData = [4, 2, 1.6, 0.8, 0, 1, 2, 4, 4.5];

  if (activeDashboard === "live" && comp?.data) {
    const prevEmp = comp.data.previousYear?.employees || {};
    const currEmp = comp.data.currentYear?.employees || {};
    const prevWkr = comp.data.previousYear?.workers || {};
    const currWkr = comp.data.currentYear?.workers || {};

    empPrevData = [
      prevEmp[
        "previous_year_permanent_employees_total_recordable_workrelated_injuries"
      ] || 0,
      prevEmp["previous_year_permanent_employees_lost_time_injuries"] || 0,
      prevEmp[
        "previous_year_permanent_employees_rate_recordable_workrelated_injuries"
      ] || 0,
      prevEmp[
        "previous_year_permanent_employees_lost_time_injury_frequency_rate"
      ] || 0,
      prevEmp["previous_year_permanent_employees_no_of_fatalities"] || 0,
      prevEmp[
        "previous_year_permanent_employees_high_consequence_workrelated_injury_or_ill_health"
      ] || 0,
      prevEmp["previous_year_permanent_employees_medical_treatment_cases"] || 0,
      prevEmp["previous_year_permanent_employees_work_related_injuries"] || 0,
      prevEmp[
        "previous_year_permanent_employees_severity_rate_without_fatality"
      ] || 0,
    ];

    empCurrData = [
      currEmp[
        "current_year_permanent_employees_total_recordable_workrelated_injuries"
      ] || 0,
      currEmp["current_year_permanent_employees_lost_time_injuries"] || 0,
      currEmp[
        "current_year_permanent_employees_rate_recordable_workrelated_injuries"
      ] || 0,
      currEmp[
        "current_year_permanent_employees_lost_time_injury_frequency_rate"
      ] || 0,
      currEmp["current_year_permanent_employees_no_of_fatalities"] || 0,
      currEmp[
        "current_year_permanent_employees_high_consequence_workrelated_injury_or_ill_health"
      ] || 0,
      currEmp["current_year_permanent_employees_medical_treatment_cases"] || 0,
      currEmp["current_year_permanent_employees_work_related_injuries"] || 0,
      currEmp[
        "current_year_permanent_employees_severity_rate_without_fatality"
      ] || 0,
    ];

    wkrPrevData = [
      prevWkr[
        "previous_year_permanent_workers_total_recordable_workrelated_injuries"
      ] || 0,
      prevWkr["previous_year_permanent_workers_lost_time_injuries"] || 0,
      prevWkr[
        "previous_year_permanent_workers_rate_recordable_workrelated_injuries"
      ] || 0,
      prevWkr[
        "previous_year_permanent_workers_lost_time_injury_frequency_rate"
      ] || 0,
      prevWkr["previous_year_permanent_workers_no_of_fatalities"] || 0,
      prevWkr[
        "previous_year_permanent_workers_high_consequence_workrelated_injury_or_ill_health"
      ] || 0,
      prevWkr["previous_year_permanent_workers_medical_treatment_cases"] || 0,
      prevWkr["previous_year_permanent_workers_work_related_injuries"] || 0,
      prevWkr[
        "previous_year_permanent_workers_severity_rate_without_fatality"
      ] || 0,
    ];

    wkrCurrData = [
      currWkr[
        "current_year_permanent_workers_total_recordable_workrelated_injuries"
      ] || 0,
      currWkr["current_year_permanent_workers_lost_time_injuries"] || 0,
      currWkr[
        "current_year_permanent_workers_rate_recordable_workrelated_injuries"
      ] || 0,
      currWkr[
        "current_year_permanent_workers_lost_time_injury_frequency_rate"
      ] || 0,
      currWkr["current_year_permanent_workers_no_of_fatalities"] || 0,
      currWkr[
        "current_year_permanent_workers_high_consequence_workrelated_injury_or_ill_health"
      ] || 0,
      currWkr["current_year_permanent_workers_medical_treatment_cases"] || 0,
      currWkr["current_year_permanent_workers_work_related_injuries"] || 0,
      currWkr[
        "current_year_permanent_workers_severity_rate_without_fatality"
      ] || 0,
    ];
  }

  return (
    <div className="p-4 w-full">
      {/* Title Section */}
      <div className="flex items-center flex-wrap gap-4">
        <div className="w-12">
          <TitleImage className="w-13 h-13" />
        </div>
        <p className="text-lg font-semibold">
          Health & Safety Related Incidents
        </p>
      </div>

      {/* Charts Section */}
      <div className="flex flex-col lg:flex-row justify-between mt-10 gap-8">
        {/* Permanent Employees */}
        <div className="w-full relative z-10 hover:z-20">
          <div className="flex items-center justify-between px-4 mb-4">
            <p className="font-calibri font-bold text-[14px] tracking-normal">
              Permanent Employees
            </p>
            <div className="flex gap-4">
              <Legend color={THEME_COLORS.green} label="Previous Year" />
              <Legend color={THEME_COLORS.yellow} label="Current Year" />
            </div>
          </div>

          <div className="overflow-x-auto lg:overflow-visible">
            <TwoBarHorizontalGraph
              data={[{ data: empPrevData }, { data: empCurrData }]}
              categories={[
                ["Total Record of", "work related injuries"],
                ["Lost Time", "Injuries"],
                ["Rate of relatable", "Work Related Injuries"],
                ["Lost Time Injuries", "Frequency Rate"],
                "No of Fatalities",
                ["High consequence work-", "related injury or ill-health"],
                ["Medical Treatment", "Cases"],
                "Work Related Injuries",
                ["Severity Rate", "Without Fatality"],
              ]}
              colors={[THEME_COLORS.green, THEME_COLORS.yellow]}
              barNames={["Previous Year", "Current Year"]}
              yAxisWidth={170}
            />
          </div>
        </div>

        {/* Permanent Workers */}
        <div className="w-full relative z-10 hover:z-20">
          <div className="flex items-center justify-between px-4 mb-4">
            <p className="font-calibri font-bold text-[14px] tracking-normal">
              Permanent Workers
            </p>
            <div className="flex gap-4">
              <Legend color={THEME_COLORS.green} label="Previous Year" />
              <Legend color={THEME_COLORS.yellow} label="Current Year" />
            </div>
          </div>

          <div className="overflow-x-auto lg:overflow-visible">
            <TwoBarHorizontalGraph
              data={[{ data: wkrPrevData }, { data: wkrCurrData }]}
              categories={[
                ["Total Record of", "work related injuries"],
                ["Lost Time", "Injuries"],
                ["Rate of relatable", "Work Related Injuries"],
                ["Lost Time Injuries", "Frequency Rate"],
                "No of Fatalities",
                ["High consequence work-", "related injury or ill-health"],
                ["Medical Treatment", "Cases"],
                "Work Related Injuries",
                ["Severity Rate", "Without Fatality"],
              ]}
              colors={[THEME_COLORS.green, THEME_COLORS.yellow]}
              barNames={["Previous Year", "Current Year"]}
              yAxisWidth={170}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const Legend = ({ color, label }) => (
  <div className="flex items-center gap-2">
    <div className="w-4 h-4 rounded" style={{ backgroundColor: color }}></div>
    <span className="text-xs font-light">{label}</span>
  </div>
);

export default HealthAndSafety;
